import classNames from 'classnames';
import { AlternativeButton } from 'components/1-atoms/Buttons';
import { Heading, HeadingLevel } from 'components/1-atoms/Heading';
import { RichText } from 'components/1-atoms/RichText';
import * as React from 'react';
import { useRef, useState } from 'react';
import styles from './ExampleBox.module.scss';

export interface ExampleBoxProps {
	className?: string;
	id?: string;
	header?: string;
	headerLevel?: HeadingLevel;
	text?: string;
	openText?: string;
	closedText?: string;
	enableFold?: boolean;
	style?: 'medium' | 'light';
	float?: 'Right';
}

export const ExampleBox: React.FC<ExampleBoxProps> = ({
	className,
	id,
	header,
	headerLevel = 'h2',
	openText,
	closedText,
	enableFold,
	text,
	style = 'medium',
	float,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const contentElement = useRef<HTMLDivElement>(null);

	return (
		<div
			className={classNames(styles.ExampleBox, float && styles[`ExampleBox___focus${float}`], className, {
				[styles.ExampleBox___light]: style === 'light',
			})}
		>
			<Heading className={styles.ExampleBox_heading} headingLevel={headerLevel} style="md">
				{header}
			</Heading>
			{!enableFold && <RichText className={styles.ExpandBox_content} content={text} />}
			{enableFold && (
				<>
					<div className={classNames(styles.ExampleBox_collapse, { [styles.ExampleBox_collapse___closed]: !isOpen })} ref={contentElement}>
						{isOpen ? null : <div className={styles.ExampleBox_overlay} />}
						<RichText className={styles.ExpandBox_content} content={text} />
					</div>
					<AlternativeButton
						aria-controls={id}
						aria-expanded={isOpen}
						className={styles.ExampleBox_button}
						onClick={() => {
							setIsOpen(!isOpen);
							if (!isOpen) {
								contentElement?.current?.scrollIntoView();
							}
						}}
						label={!isOpen ? openText : closedText}
						icon={!isOpen ? 'ArrowDown' : 'ArrowUp'}
					/>
				</>
			)}
		</div>
	);
};
